const fr = {
  numberOfChargers: `Nombre de chargeurs`,
  numberOfChargingSessions: `Nombre de sessions de charge`,
  numberOfUsers: `Nombre d'utilisateurs`,
  numberOfVehicles: `Nombre de véhicules`,
  numberOfKWH: `Nombre de KW`,
  chargingAmount: `Nombre de sessions de charge`,
  chargeAmount: `Nombre de frais`,
  chargerStatus: `État du chargeur`,
  usersLogged: `Utilisateurs connectés`,
  username: `Nom d'utilisateur`,
  password: `Mot de passe`,
  passwordConfirm: `Confirmer le mot de passe`,
  updatePasword: `Modifier le mot de passe?`,
  close: `Fermer`,
  createButton: `Créer`,
  userGroupRequired: 'Le groupe d\'utilisateur est requis',
  group: `Groupe`,
  address1: `Adresse 1`,
  billingFrequencyRequired: `La fréquence de facturation est requise`,
  billingFrequency: `Fréquence de facturation`,
  address2: `Adresse 2`,
  deleteAgent: `Supprimer l'agent`,
  addCreditToGroup: `Ajouter des credits au groupe:`,
  maxPower: `Puissance maximale`,
  forgotPassword: `Mot de passe oublié ?`,
  rememberMe: `Se souvenir de moi`,
  dataNotFound: `Aucune données`,
  addCredit: `Ajouter des credits`,
  signin: `Connexion à Seeligg Backoffice`,
  insertDetails: `Entrez vos coordonnées ci-dessous`,
  login: `Connexion`,
  logout: `Quitter`,
  welcome: `Bienvenue à`,
  seeliggExplain: 'Plateforme de gestion de la recharge des voitures électriques',
  email: `Email`,
  name: `Prénom`,
  surname: `Nom de famille`,
  firstname: `Prénom`,
  lastname: `Nom de famille`,
  phoneNumber: 'Téléphone',
  moeda: `Pièce`,
  faturation: `Faturation`,
  minWalletValue: `Valeur min. Portefeuille`,
  address: `Adresse`,
  image: 'Image',
  year: `Année`,
  of: `de`,
  balance: `Solde`,

  chargingProfiles: 'Profils de Chargement',
  addChargingProfile: 'Ajouter un profil de chargement',
  editChargingProfile: 'Modifier un profil de chargement',

  resultsNotFound: `Aucun résultat`,
  chargerPictures: `Images du chargeur`,

  postalCode: `Code postal`,
  city: `Ville`,
  editTariff: `Modifier le tarif`,
  createTariff: `Créer un tarif`,
  country: `Pays`,
  connector: `Connecteur`,
  id: `ID`,
  active: `Actif`,
  inactive: `Inactif`,
  deleteProvider: `Etes-vous sûr de vouloir supprimer le fournisseur`,
  deleteGroup: `Etes-vous sûr de vouloir supprimer le groupe`,
  addConnector: `Ajouter un connecteur`,
  removeFromGroup: `Retirer du groupe`,
  addToGroup: `Ajouter au groupe`,
  creditsAmount: `Montant des crédits`,
  addCreditsToUser: `Ajouter des credits à l'utilisateur`,
  chargerGrop: `Chargeur Groupe`,
  fromGroup: `de ce groupe?`,
  providersGroups: `Groupes de fournisseurs`,
  deleteUser: `Etes-vous sûr de vouloir supprimer l'utilisateur`,
  chargerGropuAssociate: `Chargeur Groupe Associé a -`,
  searchEmailUsername: `Rechercher par email ou nom d'utilisateur`,
  usersAssociateTo: `Utilisateurs associés a -`,
  remove: 'Supprimer',
  changeTariffPrice: `Modifier le tarif`,
  minWalletValue: `Valeur min. Wallet`,
  openMultiSeccion: `Activer les sessions multiples`,
  serialNumberRequired: `Numéro de série requis`,
  postalCode: `Code postal`,
  deleteCharger: 'Etes-vous sûr de vouloir supprimer ce chargeur',
  language: `Langue`,
  description: `Description`,
  role: 'Rouler',
  roles: 'Rôles',
  user: `Utilisateur`,
  users: `Utilisateurs`,
  userProfile: `Profil de l’utilisateur`,
  vehicle: 'Véhicule',
  vehicles: 'Véhicules',
  charger: 'Chargeur',
  chargers: 'Chargeurs',
  maxCharger: 'Chargement maximal',
  maxAmps: `Ampères maximales`,
  maxVoltage: `Tension maximale`,
  success: 'Succès',
  successful: `avec succès.`,
  addedSucessful: `ajouté avec succès.`,
  updatedSuccessful: `mis à jour avec succès.`,
  updatePassword: `Mettre à jour le mot de passe`,
  deleteSuccessful: `supprimé avec succès.`,
  error: 'Erreur',
  errorOccured: `Une erreur s'est produite.`,
  errorOccuredTryAgain: `Une erreur s'est produite. Veuillez réessayer.`,
  errorOccuredTryAgainLater: `Une erreur s'est produite. Veuillez réessayer plus tard.`,
  vehiclesManagement: `Gestion des véhicules`,
  usersManagement: `Gestion des utilisateurs`,
  chargersManagement: `Gestion du chargeur`,
  chargersInformation: `Information du chargeur`,
  editChargerInformation: `Modifier les informations du chargeur`,
  chargersAdminMode: `Mettre les chargeurs en mode administrateur`,
  providers: `Fournisseurs`,
  provider: `Fournisseur`,
  addUser: `Ajouter un utilisateur`,
  addProvider: `Ajouter un fournisseur`,
  addVehicle: `Ajouter un véhicule`,
  addCharger: `Ajouter un chargeur`,
  addBrand: `Ajouter une marque`,
  addModel: `Ajouter un modèle`,
  addOutletType: `Ajouter une prise`,
  providersList: `Liste des fournisseurs`,
  providerGroups: `Groupes de fournisseurs`,
  providerGroup: 'Groupe',
  chargerLogs: 'Journaux du chargeur',
  chargerList: `Liste des chargeurs`,
  chargerGroups: `Groupes de chargeurs`,
  vehicleList: `Liste de véhicules`,
  usersList: `Liste des utilisateurs`,
  brandsList: `Liste des marques`,
  firmwareList: `Liste des Firmwares`,
  modelsList: `Liste de modèles`,
  outletTypesList: `Liste des points de vente`,
  payments: 'Paiements',
  settings: 'Paramètres',
  log: `Journal`,
  logs: `Journaux`,
  new: `Nouveau`,
  add: `Ajouter`,
  states: 'Etats',
  back: `Retour`,
  evNotCharging: 'EV non en cours de Chargement',
  commission: 'Commission',

  deleteSelectedUsers: 'Voulez-vous supprimer les utilisateurs sélectionnés?',
  deleteSelectedItems: 'Voulez-vous supprimer les éléments sélectionnés?',
  providerAccount: 'Origine du compte',

  priceMinValue: `La valeur minimale est 0`,
  addCreditToUser: `Ajouter des credits à l'utilisateur`,

  rejectSelectedConfirm: 'Êtes-vous sûre de vouloir rejeter les éléments sélectionnés?',
  reject: 'Rejeter',
  rejectSelected: 'Rejeter les photos sélectionnés',

  roads: 'Routes',
  satellite: 'Satellite',

  deleteItemConfirmation: 'Voulez-vous supprimer cet élément?',

  next: `Suivant`,
  providerRequired: 'Le fournisseur est requis',
  hardwareRequired: 'L’id matériel est requis',
  removeLocation: 'Supprimer l’emplacement',
  editLocation: 'Modifier l’emplacement',
  edit: 'Modifier',
  delete: `Supprimer`,
  generateQRCodes: `Générer des codes QR`,
  search: `Rechercher`,
  searchHere: `Rechercher ici...`,
  save: `Enregistrer`,
  saveChanges: `Garder`,
  cancel: `Annuler`,
  brand: `Marque`,
  brands: 'Marques',
  mode: 'Modèle',
  models: 'Modèles',
  outletType: 'Prise',
  deleteCurrentCharger: 'Etes-vous sûr de vouloir supprimer ce chargeur?',
  outletTypes: `Points de vente`,
  outletTypesAssociated: `Points de vente associés à ce modèle`,
  editUser: `Modifier l'utilisateur`,
  editUserProfile: `Modifier le profil utilisateur`,
  editUserProfilePassword: `Modifier le mot de passe de l'utilisateur`,
  editProvider: `Modifier le fournisseur`,
  editVehicle: `Modifier le véhicule`,
  editCharger: `Modifier le chargeur`,
  editMarque: `Modifier la marque`,
  editModel: `Modifier le modèle`,
  editChargerInformation: `Modifier les informations du chargeur`,
  chargersInformation: `Information du chargeur`,
  amperes: 'Amps',
  chargerGroups: `Groupes de chargeurs`,
  creditsManagement: `Gestion des credits`,
  editOutletType: `Modifier la prise`,
  editChargerLocation: `Modifier l'emplacement du chargeur`,
  deleteConfirmation: `Êtes-vous sûr de vouloir supprimer ceci`,
  deleteConfirmation: `Êtes-vous sûr de vouloir supprimer ceci`,
  createUser: `Créer un nouvel utilisateur`,
  createVehicle: `Créer un nouveau véhicule`,
  createCharger: `Créer un nouveau chargeur`,
  createBrand: `Créer une nouvelle marque`,
  createModel: `Créer un nouveau modèle`,
  createOutletType: `Créer une nouvelle prise`,
  map: `Carte`,
  list: `Liste`,
  amount: `Montant`,
  serialNumber: `Matricule`,
  dateCreated: `Date de création`,
  dateChange: `Date de modification`,
  endDate: `Date de fin`,
  dataType: `Type de données`,
  entryDate: `Date d'entrée`,
  entryText: `Description du journal`,
  origin: 'Origine',
  type: `Type`,
  notifications: 'Notifications',
  profile: `Profil`,
  selected: `sélectionné`,
  tooltipTitle: `Veuillez sélectionner les items dans le tableau, puis appuyez sur ce bouton`,
  chooseFile: `Choisir un fichier`,
  noFile: `Aucun fichier sélectionné`,
  file: `Fichier`,
  selected: `sélectionné`,
  version: `Version`,
  chargingSessions: `Sessions de charge`,
  createChargingSession: `Créer une session de charge`,
  execute: `Exécuter`,
  actionToPerfom: `Quelle action de charge souhaitez-vous effectuer:`,
  terminate: `Terminer la session`,
  create: `Créer une session`,
  agent: `Agent`,
  agents: `Agents`,
  agentsList: `Liste des agents`,
  addAgent: `Ajouter un agent`,
  editAgent: `Modifier l'agent`,
  newAgent: `Nouvel agent`,
  updateFirmware: `Mettre à jour le firmware`,
  uploadFirmware: `Télécharger le firmware`,
  firmwares: `Firmwares`,
  firmware: `Firmware`,
  fileName: `Nom du fichier`,
  execute: `Exécuter`,
  delete: `Supprimer`,
  addressLine1: `Adresse ligne 1`,
  addressLine2: `Adresse ligne 2`,
  addressLine3: `Adresse ligne 3`,
  addressPostalCode: `Code postal`,
  nome: `Nom`,
  groups: `Groupes`,
  userRole: `Rôle de l'utilisateur`,
  paymentsManagement: `Gestion des paiements`,
  paymentStatus: `Statut du paiement`,
  payment: `Paiements`,
  paymentsList: `Liste des paiements`,
  paymentType: `Type de paiement`,
  invoices: `Factures`,
  invoicesList: `Liste des factures`,
  invoiceFile: `Fichier de facture`,
  paymentLogs: `Journaux de paiement`,
  paymentLogsList: `Liste des journaux de paiement`,
  networks: `Réseaux`,
  updateNetwork: `Mettre à jour le réseau`,
  chooseCharger: `Choisir un chargeur`,
  manageBillingMethod: `Gérer la méthode de facturation`,
  manageTaxFree: `Gérer la TVA`,
  billingMethod: `Méthode de facturation`,
  price: `Prix`,
  chargersWithoutLocation: `Chargeurs sans emplacement`,
  ocppChargers: 'Chargeurs OCPP',
  creditsManagement: 'Gestion des credits',
  cancel: `Annuler`,
  delete: `Supprimer`,
  details: `Détails`,
  publicAddress: `Adresse publique`,
  privateAddress: `Adresse privée`,
  macAddress: `Adresse MAC`,
  port: `Port`,
  gateway: `Passerelle`,
  subnetMask: `Masque de sous-réseau`,
  userInfo: `Informations de l'utilisateur`,
  dns: `DNS`,
  wifiSSid: `Wifi SSID`,
  wifiPassword: `Wifi mot de passe`,
  privateIP: `IP privée`,
  publicIP: `IP publique`,

  deleteProvider: 'Vous êtes sûr de vouloir supprimer le fournisseur',
  deleteCharger: 'Vous êtes de vouloir supprimer le chargeur',

  tariffs: 'Tarifs',
  tariff: 'Tarif',
  transactions: 'Transactions',
  chargementList: 'Liste des chargements',

  deleteBrand: 'Êtes-vous sûr de vouloir supprimer la marque ',
  deleteVehicle: 'Êtes-vous sûr de vouloir supprimer le véhicule ',
  deleteOutlet: 'Êtes-vous sûre de vouloir supprimer la prise du véhicule ',
  deleteModel: 'Êtes-vous sûr de vouloir supprimer le modèle ',

  // CHARGER STATES
  notConnected: `Non connecté`,
  connected: `Connecté`,
  evCharging: `Véhicule en charge`,
  evConnected: `Véhicule connecté`,
  evNotConnected: `Véhicule non connecté`,
  standby: `Veille`,

  dataNotFound: `Données non trouvées`,

  providerInformation: `Information du fournisseur`,

  chargeState: 'Etat de la charge',

  userChargeHistory: `Historique de charge de l'utilisateur`,

  addProviderMessage: `Ce chargeur n’a pas de fournisseur assigné, vous devez d’abord affecter un fournisseur pour pouvoir modifier l’emplacement`,

  addProviderFirst: `Veuillez ajouter un fournisseur d'abord`,
  public1: `Publique`,
  private1: `Privée`,

  private: `Privée?`,
  yes: `Oui`,
  no: `Non`,
  copyGroup: `Copier le groupe`,
  groupCopySucessful: `Le groupe a été copié avec succès.`,

  generatePaymentLogsChart: `Générer un graphique de paiement`,

  changeProvider: 'Changer de fournisseur',
  changeWifiNetwork: 'Changer de réseau Wifi',

  useLoadBalance: 'Utiliser LoadBalance',

  // ------------------REQUIRED DATA---------------------------
  chargerRequired: `Chargeur est requis`,
  vehicleRequired: `Véhicule est requis`,
  optionRequired: `Option est requise`,

  firstnameRequired: `Prenom est requis`,
  lastnameRequired: `Nom est requis`,
  passwordConfirmRequired: `Confirmer le mot de passe est requis`,
  passwordMatch: `Les mots de passe ne sont pas identiques`,
  minimunLength: `Minimum de 8 caractères`,

  newPassword: `Nouveau mot de passe`,
  confirmNewPassword: `Confirmer le nouveau mot de passe`,
  currentPassword: `Mot de passe actuel`,
  validEmail: `Veuillez insérer un email valide`,

  deleteBrand: 'Êtes-vous sûr de vouloir supprimer la marque ',
  deleteVehicle: 'Êtes-vous sûr de vouloir supprimer le véhicule ',
  deleteOutlet: 'Êtes-vous sûre de vouloir supprimer la prise du véhicule ',
  deleteModel: 'Êtes-vous sûr de vouloir supprimer le modèle ',

  userNameRiquired: `Nom d'utilisateur est requis`,
  phoneRequired: `N° de telephone est requis`,
  emailRequired: `Email est requis`,
  passwordRequired: `Mot de passe est requis`,
  nameRequired: `Nom est requis`,
  powerRequired: `Puissance est requise`,
  deleteTariff: `Êtes-vous sûr de vouloir supprimer tarif`,
  tariffList: `Liste des tarifs`,
  tariff: `Tarif`,
  addGroup: 'Ajouter Group',
  editGroup: 'Modifier le groupe',
  print: `Imprimer`,
  tariffsManagement: `Gestion des tarifs`,
  transactions: `Transactions`,
  newTransaction: `Nouvelle transaction`,
  transactionsManagemant: `Gestion des transactions`,
  credits: `Crédits`,
  observation: `Observation`,
  chargerProvider: `Fournisseur de chargeur`,
  maxCharge: `Puissance maximale`,
  countryRequired: `Pays est requis`,
  maxVoltage: `Tension de charge maximale`,
  loadebalanceLimit: `Limite de charge`,
  operation: `Opération`,
  typeRequired: `Type est requis`,
  firmwareVersion: `Version du micrologiciel`,
  deleteVehicleMessage: `Vous êtes sûr de vouloir supprimer tous ces véhicules?`,
  sorryPageNotFound: `Deu pas trouver trouver cette page`,
  pageNotFoundTitle:
    'Désolé, nous n’avons pas trouvé la page que vous recherchez. Peut-être avez-vous mal tapé l’URL ? Assurez-vous de vérifier votre orthographe.',
  goHome: `Rentre chez toi`,
  tryLatter: `Une erreur s’est produite, veuillez réessayer plus tard.`,
  title404: `404 Page introuvable`,
  title500: `500 Erreur interne du serveur`,
  ocppChargers: 'Ocpp Chargers',
  ocppChargersList: 'Liste des ocpp chargers',
  walletstransactions: `Transactions de portefeuille`,
  currencyRequired: `Devise est requise`,
  taxeRequired: `Regime fiscal est requis`,
  counrtyRequired: `Pays est requis`,
  websiteRequied: `Site web est requis`,
  emailValide: `Email doit être un email valide`,
  addressRequired: `Adresse est requise`,
  postalCodeRequired: `Code postal est requis`,
  paymentMethodRequired: `Méthode de paiement est requise`,

  timeStart: 'Heure de Début',
  timeEnd: 'Heure de Fin',
  totalEnergy: 'Énergie Totale',
  totalCost: 'Coût Total',

  duration: 'Durée',

  stateDescription: {
    notConnected: "Le chargeur n'est pas connecté à la plateforme",
    evCharging: 'Le véhicule est en cours de chargement',
    evConnected: 'Le véhicule est connecté au chargeur mais ne charge pas',
    evNotConnected: "Le véhicule n'est pas connecté au chargeur",
    standby: 'Le chargeur est en veille',
    noHeart: "Le chargeur n'a pas envoyé de données depuis plus de 5 minutes",
  },

  state: 'État',

  chargements: 'Chargements',
  energy: 'Énergie',

  addTaX: 'Ajouter un impôt',
  editTax: "Modifier l'impôt",
  tax: 'Impôt',
  taxes: 'Impôts',
  removeProfie: 'Supprimer le profil de chargement',
  taxesList: 'Liste des impôts',
  value: 'Valeur',
  chargingProfile: `Profil de chargement`,
  chargingProfileRequired: `Profil de chargement est requis`,
  removeProfileConfirm: 'Étes-vous sûr de vouloir supprimer ce profil de chargement?',
  stackLevelIteger: 'Le niveau de pile doit être un entier',
  stackLevelrequired: 'Le niveau de pile est requis',
  chargingProfileKindRequired: 'Le type de profil de chargement est requis',
  chargingRateUnitRequired: 'Le type de profil de chargement est requis',
  durationMustBeIteger: 'La durée doit être un entier',
  SchedulePeriodrequired: 'Le type de profil de chargement est requis',
  startPeriodRequired: 'La période de début est requise',
  limitIsRequired: 'Une limite est requise',
  addSchedulePeriod: 'Ajouter un point',
  addProfile: 'Ajouter un profil',

  stackLevel: 'Niveau de pile',
  chargingProfilePurpose: 'Objectif du profil',
  chargingProfileKind: 'Type de profil',
  recurrenceKind: 'Type de récurrence',
  chargingRateUnit: 'Unité de taux de charge',	
  minChargingRate: 'Min. Taux de charge',
  duration: 'Durée',
  startPeriod: 'Période de début',
  limit: 'Limite',
  numberPhases: 'Nombre de phases',
  schedulePeriod: 'Schedule Period',
  validFrom: 'Valable à partir de',
  validTo: `Valable jusqu'à`,
  startSchedule: 'Programme de démarrage',
  viewProviles: 'Voir les profils',
  company: 'Compagnie',

  chargerGroupRequired: 'Le groupe de chargeur est requis',
  firmwareRequired: `Le firmware est requis`,
  retrieveDateRequired: `La date de récupération est requise`,

  available: {
    from: 'Disponible à partir de',
    until: `Disponible jusqu'à`,
  },

  deleteChargingProfiles: `Étes-vous sûr de vouloir supprimer ce profil de chargement?`,
  deleteChargingProfile: `Supprimer le profil de chargement`,
  start_schedule: 'Horraire de Démarrage',

  valid: {
    from: 'Valide à partir de',
    until: 'Valide jusqu’à',
  },

  acess: 'Accès',

  confirmation: 'Confirmation',
  enable: 'Activer',
  disable: 'Désactiver',
  disableMessage: 'Désactiver tous les chargeurs sélectionnés?',
  enabledMessage: 'Activer tous ces chargeurs sélectionnés?',
  deleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer tous ces chargeurs sélectionnés?',

  hourly: 'Par heure',
  daily: 'Par jour',
  weekly: 'Quotidien',
  biweekly: 'Bihebdomadaire',
  monthly: 'Par mois',
  yearly: 'Par an',
  logout: 'Déconnexion',
  status: `Statut`,
  habilitarfaturacao: 'Activer la facturation',
  openFreeCharge: `Activer la recharge gratuite`,
  freeCharge: `Chargem. libre`,
  sendCommand: `Envoyer commander`,
  website: 'Site web',
  command: `Commander`,
  send: `Envoyer`,
  message: `Message`,
  connectorRequired: `Un connecteur est requis`,
  removeConnectorConfirmation: `Voulez-vous vraiment retirer ce connecteur ?`,
  availability: `Disponibilité`,
  confKey: `Clé de configuration`,
  chargersWithoutProvisioning: `Chargeurs non enregistrés `,
  userGroups: `Groupes d'utilisateurs`,
  currency: `Monnaie`,
  currentPerPhase: `Courant par phase`,
  paymentType: `Type de paiement`,
  availabilityWarning: ` L’heure de début de la disponibilité du chargeur doit être inférieure à l’heure de fin de la disponibilité du chargeur !`,
  deleteAllGroupsMessage: "Êtes-vous de vouloir supprimer tous les groupes d'utilisateurs ?",
  deleteProviders: `Êtes-vous sûr de vouloir supprimer tous ces fournisseurs ?`,

  defineTariffPrice: `Fixez le prix de chaque tarif`,
  tariffPrice: `Le prix doit être fixé dans votre devise locale`,
  chargingUpTo: ` - chargement jusqu’à`,

  addChargerGroup: 'Ajouter un groupe de chargers',
  editChargerGroup: 'Modifier le groupe de chargers',
  provisioningDate: `Date d’approvisionnement`,
  rate: `Taux`,

  freeCharger: 'Chargeur gratuit',
  chargingReport: `Rapport de Chargement`,
  chargingReports: `Rapports de chargement`,
  chargeReportsList: `Liste des rapports de chargement`,
  user_charger: 'Utilisateur / Chargeur',

  glossary: 'Glossaire',
  filter: 'Filtre',
  multipleSessions: 'Sessions multiples',

  associateUser: 'Associer le(s) RFID(s) au client',
  removeRFIDToUser: "Supprimer RFID(s) du client",
  removeRFIDConfirm: 'Supprimer RFID(s) de toutes les clientes sélectionnées?',
  pictureUnapproved: `Désapprouver, sélectionner pour approuver`,
  pictures: 'Photos',

  noResultsFor: `Aucun résultat n’a été trouvé pour `,
  checkingKeywords: `. Essayez de vérifier s’il y a des fautes de frappe ou d’utiliser des mots entiers.`,
  pleaseEnterKeywords: `S’il vous plaît entrer des mots-clés`,

  update: `Mettre à jour `,
  addressLine: 'Adresse', 
  upload: `Télécharger `,
  verifyEmail: `Vérifier votre email`,
  verifyEmailTitle: `Vérifier votre email pour activer votre compte.`,

  currentPerPhaseRequired: `Le courant par phase est requis`,
  priceRequired: `Le prix est requis`,

  chargementList: 'Liste des chargements',
  exportToExcel: 'Exporter vers Excel',
  disassociate: 'Dissocier',
  location: 'Emplacement',
  updateChargerLocation: 'Mettre à jour l’emplacement du chargeur ?',

  manufacturer: 'Fabricant', 
  firmware_version: 'Version Firmware',

  information: 'Information',
  network: 'Red',

  imageRequired: "L'image est requise",

  approveSelected: 'Approuver les photos selectionées',
  picturesSelected: ' image(s) sélectionnée(s)',
  noPicturesSelected: 'Aucune image sélectionnée',
  approve: 'Approuver',
  approveSelectedConfirm: 'Êtes-vous sûre de vouloir approuver les images sélectionnées?',

  billingType: `Type de facturation`,
  minValue: `Valeur minimale`,
  mangePaymentTypeChargers: `Ici, vous pouvez gérer le type de paiement pour les chargeurs sélectionnés.`,
  rfiList: 'Liste des RFID',

  removeRFI: "Supprimer le RFID",
  deleteRFIDMEssage: 'Êtes-vous de vouloir supprimer la RFID ',
  removeRFIDConfirmation: 'Vous êtes sûr de vouloir supprimer la RFID ',
  fromUser:  " de l'utilisateur ",

  search: {
    email: 'Rechercher par email',
    username: 'Rechercher par nom d utilisateur',
    emailOrUsername: 'Rechercher par email ou nom d utilisateur',
    button: 'Rechercher',
  },

  operationSusscessfuly: `Operação realizada com sucesso`,

  commands: {
    start: 'Démarrer la charge',
    stop: 'Terminer la charge',
    startDebugMode: 'Démarrer le mode de débogage',
    stopDebugMode: 'Fin du mode de débogage',
    foreChargeStop: 'Forcer la fin de la charge',
  },
};

export default fr;
